<template>
  <v-layout justify-center align-center>
    <v-flex>
      <v-card>
        <v-card-title><h2>Splošno</h2></v-card-title>
        <v-card-text>
          <h3>Verzija</h3>
          <p>{{ appVersion }}</p>
          <h3>Zadnje spremembe</h3>
          <p>{{changelog}}</p>
          <h3>Avtorji</h3>
          <p>KRDM Dev Team</p>
        </v-card-text>
      </v-card>
      <br>
      <v-card>
        <v-card-title><h2>Semafor napredka</h2></v-card-title>
        <v-list two-line>
          <v-list-tile v-for="item in items" :key="item.id">
            <v-list-tile-avatar>
              <v-icon>{{ item.done ? 'check' : 'close' }}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ item.description }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      appVersion: process.env.VERSION,
      changelog: 'Vpis/registracija',
      items: [
        {
          id: '1',
          title: 'Zaloga',
          description: 'prikaz trenutnega stanja hladilnika',
          done: true,
        },
        {
          id: '2',
          title: 'Who is online',
          description: 'prikaz nazadnje prisotnih v placu',
          done: true,
        },
        {
          id: '3',
          title: 'Prijava',
          description: 'prijava in user level specific',
          done: true,
        },
        {
          id: '4',
          title: 'Loaders',
          description: 'indikatorji nalaganja vsebine',
          done: false,
        },
        {
          id: '8',
          title: 'Notificatons',
          description: 'App wide messaging service (info about events, status etc)',
          done: false,
        },
        {
          id: '5',
          title: 'Store',
          description: 'vuex store',
          done: false,
        },
        {
          id: '6',
          title: 'Koledar',
          description: 'termini vaj, špili, sestanki, akcije, žuri...',
          done: false,
        },
        {
          id: '7',
          title: 'Imenik',
          description: 'Seznam članov in skupin (bendi, fitnes) z odgovorno osebo',
          done: false,
        },
      ],
    };
  },
};
</script>
